// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:55:39.455Z
// Property: Pheasant Pointe (ID: 6767906449166901)
// Collections: 24 amenities, 4 floorplans (live), 32 photos, 42 POIs, 1 reviews, 6 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166901",
  "property_external_id": "495821",
  "property_zillow_url": "https://www.zillow.com/homedetails/Stonecreek-Dr-Sacramento-CA-95833/2123733169_zpid/",
  "property_apartments_url": "https://www.apartments.com/pheasant-pointe-sacramento-ca/ck90j4f/",
  "property_google_business_url": "https://www.google.com/maps/place/Pheasant+Pointe+Apartments/data=!4m2!3m1!1s0x0:0x655d238303448636?sa=X&ved=2ahUKEwjf8afKkrySAxUVmmoFHT4kLS0Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "55609543285",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495821 p0505489",
  "property_status": null,
  "property_slug": "pheasant-pointe",
  "property_name": "Pheasant Pointe",
  "property_website_url": "https://www.apartments-sacramento.net/",
  "property_domain": "https://www.apartments-sacramento.net/",
  "property_address": "2660 Stonecreek Drive",
  "property_full_address": "2660 Stonecreek Dr, Sacramento, CA 95833",
  "property_address_1": "2660 Stonecreek Drive",
  "property_address_2": null,
  "property_address_city": "Sacramento",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95833",
  "property_address_country": "US",
  "property_address_county": "Sacramento County",
  "property_neighborhood_address": "North Sacramento",
  "property_address_latitude": "38.61400510000001",
  "property_address_longitude": "-121.492092",
  "property_email": "pheasantpointe@ctlmanagement.com",
  "property_phone": "(279) 263-9756",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Pheasant Pointe in Sacramento, experience a vibrant lifestyle tailored to your needs. Choose from spacious one- and two-bedroom floor plans, vibrant amenities like a refreshing pool, fitness center, and dog park. With social activities and a welcoming community, your ideal home awaits. Discover your perfect space today!",
  "property_long_description": "**Welcome to Pheasant Pointe – Your Ideal Sacramento Retreat!**\n\nDiscover the perfect blend of comfort, convenience, and community at Pheasant Pointe, where our thoughtfully designed one- and two-bedroom apartments cater to your lifestyle needs. Set in the vibrant heart of Sacramento, our stunning property offers a variety of spacious floor plans featuring large bedrooms, walk-in closets, and private balconies or patios, providing you with a serene escape just steps from your door.\n\nEnjoy a wealth of exceptional amenities designed to enhance your living experience. Unwind at our inviting pool, challenge yourself at the state-of-the-art fitness center, or enjoy quality time at our playground and basketball court. The clubhouse is the ideal spot for socializing, and we regularly host planned activities to foster a strong sense of community. Pet owners will appreciate our expansive dog park and designated pet play area, ensuring your furry friends have a welcoming home too!\n\nOur gated community features controlled access and on-site management for your peace of mind, complemented by convenient online services. Each apartment comes equipped with modern conveniences, including air conditioning, high-speed internet access, and in-unit washer/dryer options. With smoke-free living and wheelchair accessibility, we cater to diverse lifestyles.\n\nLocated conveniently near public transportation, Pheasant Pointe delivers both a tranquil living atmosphere and easy access to the vibrant offerings of Sacramento. \n\nFind your new home today at Pheasant Pointe! Browse our availability or schedule a tour to visit our welcoming community. Experience the lifestyle you deserve!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d2c39-2295-758e-900c-253df1f4f69b.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of the apartment building's office entrance with landscaping and a fountain.",
    "public_id": "019d2c39-2295-758e-900c-253df1f4f69b",
    "storage_key": "property/6767906449166901/019d2c39-2295-758e-900c-253df1f4f69b.webp",
    "width": 1800,
    "height": 840
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "215",
  "property_year_built": "1985",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.20930232558139",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "$500-600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $30",
  "property_online_leasing_url": "https://apartments-sacramento.securecafe.com/onlineleasing/pheasant-pointe-0/guestlogin",
  "property_resident_portal_url": "https://apartments-sacramento.securecafenet.com/residentservices/pheasant-pointe-0/userlogin",
  "property_apply_now_url": "https://apartments-sacramento.securecafe.com/onlineleasing/pheasant-pointe-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d97ae-181c-753a-8bd7-d8478ff37265.webp",
  "property_primary_logo_media": {
    "alt_text": "Pheasant Pointe Apartments logo",
    "public_id": "019d97ae-181c-753a-8bd7-d8478ff37265",
    "storage_key": "property/6767906449166901/019d97ae-181c-753a-8bd7-d8478ff37265.webp",
    "width": 785,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019db151-13d5-77fb-8854-112966b6e779.webp",
  "property_secondary_logo_media": {
    "alt_text": "Pheasant Pointe Apartments logo",
    "public_id": "019db151-13d5-77fb-8854-112966b6e779",
    "storage_key": "property/6767906449166901/019db151-13d5-77fb-8854-112966b6e779.webp",
    "width": 785,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d97ae-181c-753a-8bd7-d8478ff37265.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Pheasant Pointe Apartments logo",
    "public_id": "019d97ae-181c-753a-8bd7-d8478ff37265",
    "storage_key": "property/6767906449166901/019d97ae-181c-753a-8bd7-d8478ff37265.webp",
    "width": 785,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019db151-13d5-77fb-8854-112966b6e779.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Pheasant Pointe Apartments logo",
    "public_id": "019db151-13d5-77fb-8854-112966b6e779",
    "storage_key": "property/6767906449166901/019db151-13d5-77fb-8854-112966b6e779.webp",
    "width": 785,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "1",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "860 - 887",
  "property_sqft_min": "860",
  "property_sqft_max": "887",
  "property_price_range": "1695 - 2230",
  "property_price_min": "1695",
  "property_price_max": "2230",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/pheasantpointeapartmenthomes/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJex8pTf3WmoARNoZEA4MjXWU",
  "property_youtube_url": "https://www.youtube.com/watch?v=0ZhSXFUtrgY",
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Apartments&find_loc=natomas%2C+sacramento%2C+ca",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Pheasant Pointe",
  "property_home_romance_title": "Embrace Life and Love at Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Pheasant Pointe, where comfort meets convenience in vibrant Sacramento! Choose from spacious one- and two-bedroom floor plans, unwind by the sparkling pool, or elevate your fitness game in our modern gym. With engaging social activities, a dog park, and so much more, your ideal home awaits!",
  "property_home_floorplans_blurb": "Welcome to Pheasant Pointe, where comfort meets style in the heart of Sacramento, CA. Our thoughtfully designed floor plans offer versatile living spaces tailored to your lifestyle. Browse our available apartments and envision your new home, where modern amenities and a vibrant community come together seamlessly. Your ideal sanctuary awaits!",
  "property_home_gallery_blurb": "At Pheasant Pointe in Sacramento, CA, your dream lifestyle awaits. Choose from spacious one or two-bedroom floor plans, all featuring modern amenities like a refreshing pool, a state-of-the-art fitness center, and a welcoming dog park. Picture yourself living here, where comfort meets convenience in a vibrant community!",
  "property_home_neighborhood_blurb": "At Pheasant Pointe in Sacramento, CA, choose from spacious one and two-bedroom floor plans designed for comfortable living. Nestled among esteemed educational institutions like Sacramento State and American River College, our community is perfect for families and scholars alike. Dive into local attractions and see what makes our neighborhood special!",
  "property_home_reviews_blurb": "At Pheasant Pointe in Sacramento, residents rave about the \"welcoming atmosphere and friendly staff.\" Experience a vibrant lifestyle surrounded by delightful amenities. Join a community where comfort meets camaraderie. Don’t just take our word for it—see what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Pheasant Pointe in Sacramento, CA, you'll find more than just exquisite one- and two-bedroom apartments. Nestled near esteemed institutions like Sacramento City College and Natomas High, our vibrant community offers a wealth of educational opportunities. See what's around our community and uncover local favorites and enriching points of interest!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Pheasant Pointe in Sacramento, CA, every detail is designed for your comfort and convenience. Enjoy sunny days by the pool, energizing workouts in our fitness center, or relaxing evenings on your private balcony. With amenities tailored for every lifestyle, your ideal home awaits in our vibrant community.",
  "property_applynow_blurb": "At Pheasant Pointe in Sacramento, CA, your ideal lifestyle awaits! Choose from spacious one and two-bedroom floor plans featuring modern amenities like air conditioning, walk-in closets, and private balconies. Dive into relaxation at our pool or stay active in the fitness center. Secure your future today—lease online now!",
  "property_contactus_blurb": "At Pheasant Pointe in Sacramento, CA, find your perfect home with our spacious one and two-bedroom floor plans designed for comfort and style. Each layout offers a unique ambiance to suit your lifestyle. Have questions? Contact our leasing team today and start your journey to exceptional living!",
  "property_faqs_blurb": "At Pheasant Pointe in Sacramento, CA, we offer thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Whether you’re seeking space to unwind or vibrant community living, our FAQs page is your gateway to answers that enhance your experience. Dive in and learn more about your future home!",
  "property_floorplans_blurb": "At Pheasant Pointe in Sacramento, CA, your dream apartment awaits! Choose from spacious one and two-bedroom floor plans designed for comfort and style. With an array of layouts, you’re sure to find the ideal home to suit your lifestyle. Browse our available options and envision your new beginning today!",
  "property_gallery_blurb": "At Pheasant Pointe in Sacramento, CA, vibrant living awaits in spacious one and two-bedroom homes. Picture relaxing by the pool, enjoying community events, or unwinding in our pet-friendly dog park. With modern amenities, including a fitness center and clubhouse, every day feels like a refreshing escape. Don't just dream—envision your future!",
  "property_interactivemap_blurb": "Welcome to Pheasant Pointe, where comfort meets convenience in Sacramento, CA. Choose from spacious one and two-bedroom floor plans, complemented by robust amenities like a sparkling pool, fitness center, and dog park. Use our interactive community map to pinpoint your ideal home, pricing, and enjoy a lifestyle filled with joy!",
  "property_pets_blurb": "Nestled in the heart of Sacramento, Pheasant Pointe invites you to embrace a lifestyle of comfort and community. With spacious apartments and a pet-friendly policy for indoor dogs and cats, create a home where your furry friends can thrive alongside you. Enjoy serene living with small pets, too—just bring your joy!",
  "property_referafriend_blurb": "At Pheasant Pointe in Sacramento, CA, cozy living awaits! Whether you prefer a spacious one-bedroom or a stylish two-bedroom, our diverse floor plans cater to every lifestyle. Share the joy of community by inviting a friend to join you—great friends make great neighbors! Refer a friend today and thrive together!",
  "property_residentaccess_blurb": "Welcome to Pheasant Pointe in vibrant Sacramento, CA! Enjoy the convenience of our resident portal, where you can seamlessly manage your one or two-bedroom home. Pay rent, schedule maintenance, and access essential services, all at your fingertips. Make your living experience effortless and enjoyable today!",
  "property_reviews_blurb": "At Pheasant Pointe in Sacramento, residents love the vibrant community atmosphere. One delighted tenant shares, “The staff truly makes you feel at home.” Dive into our reviews to see why so many choose to call Pheasant Pointe their sanctuary. Your new home awaits, full of comfort and camaraderie!",
  "property_created_at": "1762785031484",
  "property_scheduletour_blurb": "At Pheasant Pointe in Sacramento, CA, our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle. Nestled in a vibrant community, join our residents in embracing comfort and convenience. Ready to envision your new home? Schedule a tour and hear firsthand what makes living here exceptional!",
  "property_thankyou_blurb": "Thank you for your interest in Pheasant Pointe, where modern comfort meets vibrant Sacramento living. Our spacious one- and two-bedroom floor plans are designed to elevate your lifestyle. A team member will reach out shortly to help you find your perfect home at Pheasant Pointe. Exciting possibilities await!",
  "property_virtualtours_blurb": "Welcome to Pheasant Pointe, where Sacramento living meets style and comfort. With thoughtfully designed one and two-bedroom floor plans, our community suits your lifestyle perfectly. Immerse yourself in a virtual tour today and visualize your future home amid serene surroundings and modern amenities. Your dream apartment awaits!",
  "property_copyright": "2025 All Rights Reserved. Pheasant Pointe",
  "property_seo_title_home": "Pheasant Pointe |  Apartments in Sacramento, CA",
  "property_seo_description_home": "Elevate your lifestyle at Pheasant Pointe in Sacramento, CA! Enjoy spacious floor plans, luxury amenities like a pool, fitness center, and pet-friendly spaces.",
  "property_seo_title_floorplans": "Floor Plans | Sacramento, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Pheasant Pointe in Sacramento, CA! Choose from stylish one or two-bedroom apartments. Browse floor plans to make it yours today!",
  "property_seo_title_amenities": "Amenities | Sacramento, CA Apartments for Rent",
  "property_seo_description_amenities": "Experience comfortable living at Pheasant Pointe in Sacramento. Unwind by the pool, stay fit in our gym, or enjoy planned activities in a vibrant community!",
  "property_seo_title_gallery": "Gallery | Apartments in Sacramento, CA",
  "property_seo_description_gallery": "Experience life at Pheasant Pointe in Sacramento, CA! From stunning pools to spacious layouts, envision your perfect home with top-notch amenities.",
  "property_seo_title_virtualtours": "Virtual Tours | Pheasant Pointe Apartments",
  "property_seo_description_virtualtours": "Step into Pheasant Pointe in Sacramento! Take a virtual tour of our one and two-bedroom apartments and envision your new home today.",
  "property_seo_title_interactivemap": "Interactive Map | Pheasant Pointe Apartments",
  "property_seo_description_interactivemap": "Discover your ideal retreat at Pheasant Pointe, Sacramento! Explore spacious apartments and enjoy premium amenities with our interactive map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Sacramento, CA",
  "property_seo_description_neighborhood": "Uncover the vibrant charm of Sacramento from Pheasant Pointe! Check out local favorites, hidden gems, and everything our welcoming neighborhood has to offer.",
  "property_seo_title_contact": "Contact Us | Pheasant Pointe",
  "property_seo_description_contact": "Connect with Pheasant Pointe in Sacramento, CA! Inquire about our one- and two-bedroom floor plans, and let our leasing team assist you today!",
  "property_seo_title_faqs": "FAQs | Apartments in Sacramento, CA",
  "property_seo_description_faqs": "Discover Pheasant Pointe in Sacramento! Get answers on spacious floor plans, stunning amenities, and our vibrant community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Sacramento, CA",
  "property_seo_description_reviews": "At Pheasant Pointe in Sacramento, hear firsthand from residents about vibrant living, top-notch amenities, and a welcoming community. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Sacramento, CA",
  "property_seo_description_applynow": "Experience life at Pheasant Pointe in Sacramento: modern one and two-bedroom apartments with resort-style amenities. Apply now and secure your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Pheasant Pointe",
  "property_seo_description_residentaccess": "Unlock convenience at Pheasant Pointe! Log in to your resident portal for easy rent payments, maintenance requests, and all your community needs in Sacramento.",
  "property_seo_title_referafriend": "Refer A Friend | Pheasant Pointe",
  "property_seo_description_referafriend": "Refer a friend to Pheasant Pointe in Sacramento, CA! Great friends make great neighbors—share your love for our vibrant community today and reap the rewards!",
  "property_seo_title_scheduletour": "Schedule a Tour | Pheasant Pointe",
  "property_seo_description_scheduletour": "Experience the charm of Pheasant Pointe in Sacramento. Schedule a tour today and step into your future home surrounded by comfort and community!",
  "property_seo_title_privacy": "Privacy Policy | Pheasant Pointe",
  "property_seo_description_privacy": "At Pheasant Pointe, your privacy matters. Discover how we protect your information for a secure living experience. View our privacy policy!",
  "property_seo_title_accessibility": "Website Accessibility | Pheasant Pointe",
  "property_seo_description_accessibility": "At Pheasant Pointe, we prioritize digital inclusion with accessibility features for all. Join our welcoming Sacramento community today!",
  "property_seo_title_sitemap": "Sitemap | Pheasant Pointe",
  "property_seo_description_sitemap": "Explore Pheasant Pointe in Sacramento, CA! Check our sitemap for a layout of your future home and discover your options today!",
  "property_seo_title_thankyou": "Thank You | Pheasant Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to Pheasant Pointe in Sacramento, CA! Our team will connect soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Sacramento, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1781679944276",
  "amenities": [
    {
      "id": "ec_3127184ba4fb501dfa5250c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "86160418",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-aa95-7578-875a-a9bdab61c198.webp",
      "amenity_image_media": {
        "alt_text": "Gym equipment including treadmills, ellipticals, and a weight machine.",
        "public_id": "019d23d1-aa95-7578-875a-a9bdab61c198",
        "storage_key": "property/6767906449166901/019d23d1-aa95-7578-875a-a9bdab61c198.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Modern Fitness Center at Pheasant Pointe, California,Cardio Machines at Pheasant Pointe, Sacramento",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_745a0c9e39a62da4f41493e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "80429226",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d3338-8f98-71aa-9d6e-f32d37944449.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables with umbrellas.",
        "public_id": "019d3338-8f98-71aa-9d6e-f32d37944449",
        "storage_key": "property/6767906449166901/019d3338-8f98-71aa-9d6e-f32d37944449.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Poolside Relaxing Chairs at Pheasant Pointe, California,Poolside Lounge Chairs at Pheasant Pointe, Sacramento,Sparkling Pool at Pheasant Pointe, Sacramento California",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8071f296c911bcbb99c68526",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "80429224",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-ab5f-70cb-8a51-9c98092083a8.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool and jacuzzi area with lounge chairs and outdoor dining tables.",
        "public_id": "019d23d1-ab5f-70cb-8a51-9c98092083a8",
        "storage_key": "property/6767906449166901/019d23d1-ab5f-70cb-8a51-9c98092083a8.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Hot Tub And Pool at Pheasant Pointe, California, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0deb51d89c6187f065c22a92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "80429223",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d9a48-c4a4-705d-b4ea-f3ed84130713.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slides, swings, and climbing structures.",
        "public_id": "019d9a48-c4a4-705d-b4ea-f3ed84130713",
        "storage_key": "property/6767906449166901/019d9a48-c4a4-705d-b4ea-f3ed84130713.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Open Play Area at Pheasant Pointe, Sacramento, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9121e01873948a56a2950fb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "87846086",
      "title": "Clubhouse with Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d1c04-f912-728d-8154-c5f2f6b2d9cf.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge area with fireplace, seating, and view of the pool.",
        "public_id": "019d1c04-f912-728d-8154-c5f2f6b2d9cf",
        "storage_key": "property/6767906449166901/019d1c04-f912-728d-8154-c5f2f6b2d9cf.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Community Clubhouse at Pheasant Pointe, Sacramento, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bd47bbf9c81e88df310bcd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "86392880",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c398779ac2f70081affc6e65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "86392882",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d3338-8e69-761a-9091-55af23c30513.webp",
      "amenity_image_media": {
        "alt_text": "Amazon Hub package lockers for Pheasant Pointe apartments.",
        "public_id": "019d3338-8e69-761a-9091-55af23c30513",
        "storage_key": "property/6767906449166901/019d3338-8e69-761a-9091-55af23c30513.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Package Hub at Pheasant Pointe, Sacramento, CA 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9f40761addf6b5d88aba231",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "80429225",
      "title": "Sport Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d3338-8d43-7159-80d7-8036a9fb3419.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor basketball court with apartment buildings in the background",
        "public_id": "019d3338-8d43-7159-80d7-8036a9fb3419",
        "storage_key": "property/6767906449166901/019d3338-8d43-7159-80d7-8036a9fb3419.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Basketball Court View at Pheasant Pointe, Sacramento, CA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3dbd0528bcaec4a5f1a2b97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "85532405",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019fbc19-c315-7062-87f3-ceed182e72ac.webp",
      "amenity_image_media": {
        "alt_text": "A fenced-in dog park with green grass, a bench, and apartment buildings in the background.",
        "public_id": "019fbc19-c315-7062-87f3-ceed182e72ac",
        "storage_key": "property/6767906449166901/019fbc19-c315-7062-87f3-ceed182e72ac.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Bark Park and Bench at Pheasant Pointe, Sacramento, CA 95833,Pet Park at Pheasant Pointe, California, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41782bd6daf0d530d91fb488",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "80429222",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8d41d58eab71f068ee1735d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "86392952",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_121a03525da30cc3a3e55c24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "82390211",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53c4004d2cf8c35fb1078b46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "82390213",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d19c2baa75f06ec517c5732f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "86392950",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef17e394e8c3cf9149161338",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "80429230",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40ca67d510648f6a57a658a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "80429228",
      "title": "Central Heat And Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ed74721e4e59c7b6ddc6651",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "80429233",
      "title": "Wood Burning Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-d79e-7500-8286-e1f3dc70eeed.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a fireplace, two accent chairs, a sofa, and a sliding glass door leading to a balcony.",
        "public_id": "019e913a-d79e-7500-8286-e1f3dc70eeed",
        "storage_key": "property/6767906449166901/019e913a-d79e-7500-8286-e1f3dc70eeed.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Model living room with a fireplace and a couch at Pheasant Pointe Apartments, California, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ba678721fd8c2266cd16025",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "80429227",
      "title": "Ample Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9fbe4df61b9dd27ceaaa143",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "80429231",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3fb8a4e643afa66357f6f68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "87310444",
      "title": "Attached Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af920f7529e8301d5d35d0fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "87310443",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-d626-77df-b0aa-af7668227662.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a fireplace, sliding glass door, couch, chairs, and coffee tables.",
        "public_id": "019e913a-d626-77df-b0aa-af7668227662",
        "storage_key": "property/6767906449166901/019e913a-d626-77df-b0aa-af7668227662.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Model living room with a fireplace, a couch, two chairs, and a table at Pheasant Pointe Apartments, California, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4246702a65173da6b261a0ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "80429232",
      "title": "Open Living Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-d8c4-7675-8ed0-87e58057cb25.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a rust-colored sofa, accent pillows, and a round mirror on the wall.",
        "public_id": "019e913a-d8c4-7675-8ed0-87e58057cb25",
        "storage_key": "property/6767906449166901/019e913a-d8c4-7675-8ed0-87e58057cb25.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Model living room with a brown couch and a round mirror on the wall at Pheasant Pointe Apartments, California, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bfc51e48c1fdb3f48911ded0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "87310442",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-d8c1-73cc-b4a2-462e8cf62984.webp",
      "amenity_image_media": {
        "alt_text": "Kitchenette with dining area featuring a round table, chairs, and a laptop.",
        "public_id": "019e913a-d8c1-73cc-b4a2-462e8cf62984",
        "storage_key": "property/6767906449166901/019e913a-d8c1-73cc-b4a2-462e8cf62984.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Model dining room with a table and chairs in the middle of the room at Pheasant Pointe Apartments, California, 95833",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b87f6fb2c012ee7a894538eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "yardi",
      "external_id": "80429229",
      "title": "Cottages Available - Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-ae7b-768d-bd44-993b1f3f6a89.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings with grey siding and large chimneys.",
        "public_id": "019d23d1-ae7b-768d-bd44-993b1f3f6a89",
        "storage_key": "property/6767906449166901/019d23d1-ae7b-768d-bd44-993b1f3f6a89.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Pheasant Pointe Remodeled Cottage Building Exterior",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_5d3ae51551261162994da7ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-c6c0-71a6-a537-d6de714ff113.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, black appliances, and a sink.",
        "public_id": "019e913a-c6c0-71a6-a537-d6de714ff113",
        "storage_key": "property/6767906449166901/019e913a-c6c0-71a6-a537-d6de714ff113.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, granite countertops, and modern black appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, black appliances, and a sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_ModelKitchenFullView.jpg"
    },
    {
      "id": "ec_ae703d82cbc50aa1453db0d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-f6b9-7797-b336-ba240bbc79a5.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a balcony view.",
        "public_id": "019e913a-f6b9-7797-b336-ba240bbc79a5",
        "storage_key": "property/6767906449166901/019e913a-f6b9-7797-b336-ba240bbc79a5.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinetry, granite countertops, and modern appliances, with access to a private balcony.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a balcony view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_ModelKitchenBar.jpg"
    },
    {
      "id": "ec_b94694fc61a5a85d00ab893b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-f224-71af-8872-7ace4ee41cf7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, granite countertops, and a dining area with a laptop.",
        "public_id": "019e913a-f224-71af-8872-7ace4ee41cf7",
        "storage_key": "property/6767906449166901/019e913a-f224-71af-8872-7ace4ee41cf7.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Explore this stylish apartment kitchen featuring dark wood cabinetry, granite countertops, and essential appliances, perfect for cooking and dining.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, black appliances, granite countertops, and a dining area with a laptop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_ModelKitchenDiningRoom.jpg"
    },
    {
      "id": "ec_31ad7ae30d63bc378944be25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-d8c1-73cc-b4a2-462e8cf62984.webp",
      "image_media": {
        "alt_text": "Kitchenette with dining area featuring a round table, chairs, and a laptop.",
        "public_id": "019e913a-d8c1-73cc-b4a2-462e8cf62984",
        "storage_key": "property/6767906449166901/019e913a-d8c1-73cc-b4a2-462e8cf62984.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Cozy kitchenette and dining nook, perfect for quick meals or working from home.",
      "link": "false",
      "alt_text": "Kitchenette with dining area featuring a round table, chairs, and a laptop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_ModelDiningRoom.jpg"
    },
    {
      "id": "ec_6a44169fd6d40e3683b8ef36",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-d8c4-7675-8ed0-87e58057cb25.webp",
      "image_media": {
        "alt_text": "Living room with a rust-colored sofa, accent pillows, and a round mirror on the wall.",
        "public_id": "019e913a-d8c4-7675-8ed0-87e58057cb25",
        "storage_key": "property/6767906449166901/019e913a-d8c4-7675-8ed0-87e58057cb25.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "A well-appointed living room featuring a comfortable rust-colored sofa, decorative pillows, and a stylish round mirror. The open layout seamlessly connects to the kitchen area.",
      "link": "false",
      "alt_text": "Living room with a rust-colored sofa, accent pillows, and a round mirror on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_ModelLivingRoomKitchenBar.jpg"
    },
    {
      "id": "ec_a9a1caf63ba0c2681603ba5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-d79e-7500-8286-e1f3dc70eeed.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, two accent chairs, a sofa, and a sliding glass door leading to a balcony.",
        "public_id": "019e913a-d79e-7500-8286-e1f3dc70eeed",
        "storage_key": "property/6767906449166901/019e913a-d79e-7500-8286-e1f3dc70eeed.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable seating, and access to a private balcony for outdoor enjoyment.",
      "link": "false",
      "alt_text": "Living room with a fireplace, two accent chairs, a sofa, and a sliding glass door leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_ModelLivingRoomEntry.jpg"
    },
    {
      "id": "ec_08dc0675f9afceff4a265dbf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-d626-77df-b0aa-af7668227662.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, sliding glass door, couch, chairs, and coffee tables.",
        "public_id": "019e913a-d626-77df-b0aa-af7668227662",
        "storage_key": "property/6767906449166901/019e913a-d626-77df-b0aa-af7668227662.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Comfortable living room featuring a fireplace, plush seating, and access to a private patio. Perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Living room with a fireplace, sliding glass door, couch, chairs, and coffee tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_ModelLivingRoom(1).jpg"
    },
    {
      "id": "ec_7ac3f585c919beae3000f2bd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-ef96-74c8-85cb-b9a548226dcb.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, purple bedding, and a white dresser.",
        "public_id": "019e913a-ef96-74c8-85cb-b9a548226dcb",
        "storage_key": "property/6767906449166901/019e913a-ef96-74c8-85cb-b9a548226dcb.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, featuring a plush queen-size bed and ample storage with a stylish white dresser.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, purple bedding, and a white dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_ModelPrimaryBedroom(1).jpg"
    },
    {
      "id": "ec_cb6e47c867cfe460a6d7e641",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-f085-735a-9353-656d073ffe3e.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and dresser, with an ensuite bathroom visible.",
        "public_id": "019e913a-f085-735a-9353-656d073ffe3e",
        "storage_key": "property/6767906449166901/019e913a-f085-735a-9353-656d073ffe3e.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Step into comfort in this charming bedroom, featuring a plush queen-size bed and elegant furnishings. The adjoining bathroom offers convenience and style.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and dresser, with an ensuite bathroom visible.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_ModelPrimaryBedroomBathroom(1).jpg"
    },
    {
      "id": "ec_0104f755b4ecf19f4749b23f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913a-f099-774d-adb1-a93857dc0056.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, shower, and sink area.",
        "public_id": "019e913a-f099-774d-adb1-a93857dc0056",
        "storage_key": "property/6767906449166901/019e913a-f099-774d-adb1-a93857dc0056.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "A clean and well-maintained bathroom featuring a toilet, shower/tub combo, and a vanity with a granite countertop.",
      "link": "false",
      "alt_text": "Bathroom with a toilet, shower, and sink area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_ModelPrimaryBathroom.jpg"
    },
    {
      "id": "ec_a074154070269c4b023f1261",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913b-07a9-77d5-b7b0-e5e25ffe9c8d.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and closet.",
        "public_id": "019e913b-07a9-77d5-b7b0-e5e25ffe9c8d",
        "storage_key": "property/6767906449166901/019e913b-07a9-77d5-b7b0-e5e25ffe9c8d.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed, a black bookshelf, and a spacious closet with built-in shelving. Perfect for relaxation and storage.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, dresser, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_ModelSecondBedroom.jpg"
    },
    {
      "id": "ec_52a4882f1489e3a6d9057705",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019e913b-099e-7695-bf99-4816b49cc191.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower.",
        "public_id": "019e913b-099e-7695-bf99-4816b49cc191",
        "storage_key": "property/6767906449166901/019e913b-099e-7695-bf99-4816b49cc191.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a vanity with a granite countertop, a toilet, and a bathtub with a shower and floral shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_ModelHallBathroom.jpg"
    },
    {
      "id": "ec_f24c2bd92ef5534c519147b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-b969-73e7-9da4-dda30a35fbb8.webp",
      "image_media": {
        "alt_text": "Pheasant Pointe apartment homes monument sign surrounded by lush landscaping and trees.",
        "public_id": "019d23d1-b969-73e7-9da4-dda30a35fbb8",
        "storage_key": "property/6767906449166901/019d23d1-b969-73e7-9da4-dda30a35fbb8.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Welcome to Pheasant Pointe, where comfort and convenience meet. This exterior shot showcases our beautiful monument sign and the surrounding vibrant landscaping, creating an inviting atmosphere.",
      "link": "false",
      "alt_text": "Pheasant Pointe apartment homes monument sign surrounded by lush landscaping and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_MonumentSign.jpg"
    },
    {
      "id": "ec_8fc15b248157b6da3e81d327",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d1c04-fabc-704a-9365-9a9891fd0fcb.webp",
      "image_media": {
        "alt_text": "Office building entrance with a fountain and flowers.",
        "public_id": "019d1c04-fabc-704a-9365-9a9891fd0fcb",
        "storage_key": "property/6767906449166901/019d1c04-fabc-704a-9365-9a9891fd0fcb.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Discover our welcoming office building entrance featuring a beautiful fountain surrounded by vibrant flowers, creating an inviting first impression.",
      "link": "false",
      "alt_text": "Office building entrance with a fountain and flowers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_RemodeledClubhouseExteriorFountain.jpg"
    },
    {
      "id": "ec_a282a8e70bc70a0bdcbfe296",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-aedf-748f-b868-e94b2e59ccc7.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with lush landscaping and the office entrance visible.",
        "public_id": "019d23d1-aedf-748f-b868-e94b2e59ccc7",
        "storage_key": "property/6767906449166901/019d23d1-aedf-748f-b868-e94b2e59ccc7.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Discover comfortable living at our apartment community. This image showcases the welcoming exterior and office entrance, surrounded by beautiful landscaping.",
      "link": "false",
      "alt_text": "Apartment building exterior with lush landscaping and the office entrance visible.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_Leasing Office.jpg"
    },
    {
      "id": "ec_047f83148c03b689de23caa9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-b4be-74dd-b9aa-516fa0b00e05.webp",
      "image_media": {
        "alt_text": "Pheasant Pointe apartment homes entrance gate with monument sign.",
        "public_id": "019d23d1-b4be-74dd-b9aa-516fa0b00e05",
        "storage_key": "property/6767906449166901/019d23d1-b4be-74dd-b9aa-516fa0b00e05.webp",
        "width": 1800,
        "height": 1203
      },
      "title": "Community",
      "description": "Welcome to Pheasant Pointe apartment homes, featuring a gated entrance with a prominent monument sign and beautiful landscaping.",
      "link": "false",
      "alt_text": "Pheasant Pointe apartment homes entrance gate with monument sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_GatedEntry.jpg"
    },
    {
      "id": "ec_0b6d74a35a4aab5fce338bdf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d1c04-f27b-729e-9ad9-8442dedb66a5.webp",
      "image_media": {
        "alt_text": "Pheasant Pointe property map sign",
        "public_id": "019d1c04-f27b-729e-9ad9-8442dedb66a5",
        "storage_key": "property/6767906449166901/019d1c04-f27b-729e-9ad9-8442dedb66a5.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Welcome to Pheasant Pointe! View our community map to find your way around.",
      "link": "false",
      "alt_text": "Pheasant Pointe property map sign",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_DirectorySign.jpg"
    },
    {
      "id": "ec_37e28eff2d8ca07a770f5d6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-ae7b-768d-bd44-993b1f3f6a89.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with grey siding and large chimneys.",
        "public_id": "019d23d1-ae7b-768d-bd44-993b1f3f6a89",
        "storage_key": "property/6767906449166901/019d23d1-ae7b-768d-bd44-993b1f3f6a89.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Charming apartment buildings with grey siding and spacious chimneys offer a comfortable living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with grey siding and large chimneys.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_RemodeledCottageBuildingExterior.jpg"
    },
    {
      "id": "ec_1d956d0c0ebf0f5cfb7bd69b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-ad50-7413-b40c-f216336ed564.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured landscaping and a sidewalk.",
        "public_id": "019d23d1-ad50-7413-b40c-f216336ed564",
        "storage_key": "property/6767906449166901/019d23d1-ad50-7413-b40c-f216336ed564.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Showcasing the attractive exteriors and well-maintained grounds of the apartment community.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with manicured landscaping and a sidewalk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_RemodeledBuildingExterior01.jpg"
    },
    {
      "id": "ec_3ddf1763105e954fe892d215",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-b009-7631-8d7a-df4cf8cb7f6a.webp",
      "image_media": {
        "alt_text": "Exterior buildings with trees and landscaping",
        "public_id": "019d23d1-b009-7631-8d7a-df4cf8cb7f6a",
        "storage_key": "property/6767906449166901/019d23d1-b009-7631-8d7a-df4cf8cb7f6a.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Exterior buildings with landscaping and trees, showcasing the community grounds.",
      "link": "false",
      "alt_text": "Exterior buildings with trees and landscaping",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_Landscaping and Exterior Buildings.jpg"
    },
    {
      "id": "ec_0e97db544607127cb7b34dd4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d1c04-f912-728d-8154-c5f2f6b2d9cf.webp",
      "image_media": {
        "alt_text": "Community lounge area with fireplace, seating, and view of the pool.",
        "public_id": "019d1c04-f912-728d-8154-c5f2f6b2d9cf",
        "storage_key": "property/6767906449166901/019d1c04-f912-728d-8154-c5f2f6b2d9cf.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Relax in our spacious community lounge, featuring a cozy fireplace, comfortable seating, and a refreshing view of the outdoor pool.",
      "link": "false",
      "alt_text": "Community lounge area with fireplace, seating, and view of the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_RemodeledClubhouseInterior.jpg"
    },
    {
      "id": "ec_b74105b67092d624b18122f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d1c04-f6f7-700e-b2dd-8adf464d1d95.webp",
      "image_media": {
        "alt_text": "Spacious leasing office with vaulted ceilings, a desk with computers, and a blue brick fireplace.",
        "public_id": "019d1c04-f6f7-700e-b2dd-8adf464d1d95",
        "storage_key": "property/6767906449166901/019d1c04-f6f7-700e-b2dd-8adf464d1d95.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Welcome to our modern leasing office, featuring a comfortable seating area, workstations, and a striking blue brick fireplace with a large clock.",
      "link": "false",
      "alt_text": "Spacious leasing office with vaulted ceilings, a desk with computers, and a blue brick fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_RemodeledClubhouseLeasing.jpg"
    },
    {
      "id": "ec_400ad8655a13fd3f8ed831eb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-aa33-73aa-a21d-c6b68526887d.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, a cable crossover machine, and a leg press.",
        "public_id": "019d23d1-aa33-73aa-a21d-c6b68526887d",
        "storage_key": "property/6767906449166901/019d23d1-aa33-73aa-a21d-c6b68526887d.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring cardio machines, strength training equipment, and more for your workout needs.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical machines, a cable crossover machine, and a leg press.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_FitnessCenter01(1).jpg"
    },
    {
      "id": "ec_0ccc77cd970642332c4aeaba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-aa95-7578-875a-a9bdab61c198.webp",
      "image_media": {
        "alt_text": "Gym equipment including treadmills, ellipticals, and a weight machine.",
        "public_id": "019d23d1-aa95-7578-875a-a9bdab61c198",
        "storage_key": "property/6767906449166901/019d23d1-aa95-7578-875a-a9bdab61c198.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring a variety of cardio machines and strength training equipment.",
      "link": "false",
      "alt_text": "Gym equipment including treadmills, ellipticals, and a weight machine.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_FitnessCenter02(1).jpg"
    },
    {
      "id": "ec_7105feb5a8ffe3696b6eb177",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-ab5f-70cb-8a51-9c98092083a8.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and jacuzzi area with lounge chairs and outdoor dining tables.",
        "public_id": "019d23d1-ab5f-70cb-8a51-9c98092083a8",
        "storage_key": "property/6767906449166901/019d23d1-ab5f-70cb-8a51-9c98092083a8.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool and rejuvenating jacuzzi. Enjoy sunny days with ample lounge seating and convenient outdoor dining areas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and jacuzzi area with lounge chairs and outdoor dining tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_SwimmingPoolSpa.jpg"
    },
    {
      "id": "ec_1ffe635916cc3de1bed5268e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d23d1-aaf9-70c6-b7c4-53db6b2297d6.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating areas.",
        "public_id": "019d23d1-aaf9-70c6-b7c4-53db6b2297d6",
        "storage_key": "property/6767906449166901/019d23d1-aaf9-70c6-b7c4-53db6b2297d6.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge chairs and shaded seating areas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and seating areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_SwimmingPool.jpg"
    },
    {
      "id": "ec_41a35937a8db9c9dd260ac88",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d3860-60de-733b-b655-d47df48c572a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
        "public_id": "019d3860-60de-733b-b655-d47df48c572a",
        "storage_key": "property/6767906449166901/019d3860-60de-733b-b655-d47df48c572a.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and convenient tables.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_SwimmingPoolLoungeChairs.jpg"
    },
    {
      "id": "ec_a0cb7628f82f3d77f05264cf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d3338-8f98-71aa-9d6e-f32d37944449.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables with umbrellas.",
        "public_id": "019d3338-8f98-71aa-9d6e-f32d37944449",
        "storage_key": "property/6767906449166901/019d3338-8f98-71aa-9d6e-f32d37944449.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables with umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_SwimmingPoolFurniture.jpg"
    },
    {
      "id": "ec_500df1cf0b8c2b27f210a25a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d3860-6a1e-7173-bc3e-7313c1cf5575.webp",
      "image_media": {
        "alt_text": "Playground with slides and swings next to apartment buildings",
        "public_id": "019d3860-6a1e-7173-bc3e-7313c1cf5575",
        "storage_key": "property/6767906449166901/019d3860-6a1e-7173-bc3e-7313c1cf5575.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our spacious playground, perfect for kids to play and burn energy. Located conveniently near apartment buildings.",
      "link": "false",
      "alt_text": "Playground with slides and swings next to apartment buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_PlayArea(2).jpg"
    },
    {
      "id": "ec_b13c5e00c52f1464e0823222",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d3338-8d43-7159-80d7-8036a9fb3419.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with apartment buildings in the background",
        "public_id": "019d3338-8d43-7159-80d7-8036a9fb3419",
        "storage_key": "property/6767906449166901/019d3338-8d43-7159-80d7-8036a9fb3419.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a game of basketball on our outdoor court, surrounded by lush greenery and modern apartment buildings. A perfect place to stay active and connect with neighbors.",
      "link": "false",
      "alt_text": "Outdoor basketball court with apartment buildings in the background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_BasketballCourt.jpg"
    },
    {
      "id": "ec_c9e56857f11ff780db45fdb7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d3338-912a-719f-9ece-a2d0b4cedc6d.webp",
      "image_media": {
        "alt_text": "Community dog park area with green grass and a black fence.",
        "public_id": "019d3338-912a-719f-9ece-a2d0b4cedc6d",
        "storage_key": "property/6767906449166901/019d3338-912a-719f-9ece-a2d0b4cedc6d.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, a perfect place for your furry friends to play and socialize within our community.",
      "link": "false",
      "alt_text": "Community dog park area with green grass and a black fence.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_BarkPark01.jpg"
    },
    {
      "id": "ec_49b4798d31137d28403847c2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d3338-8e69-761a-9091-55af23c30513.webp",
      "image_media": {
        "alt_text": "Amazon Hub package lockers for Pheasant Pointe apartments.",
        "public_id": "019d3338-8e69-761a-9091-55af23c30513",
        "storage_key": "property/6767906449166901/019d3338-8e69-761a-9091-55af23c30513.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Secure package lockers provided by Amazon Hub at Pheasant Pointe, offering residents convenient and safe delivery management.",
      "link": "false",
      "alt_text": "Amazon Hub package lockers for Pheasant Pointe apartments.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/PheasantPointe_Sacramento_CA_PackageHub.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fb898fe8-83cd-4842-8dc8-222bf1145331",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "2001 Alta Arden Expy, Sacramento, CA 95825, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious Double Doubles, animal fries, and milkshakes. They highlight the fresh food, fast service, and friendly staff. They also like the good value and efficient drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-2abe-76c9-a27e-b209ec7376e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-2abe-76c9-a27e-b209ec7376e3",
        "storage_key": "property/6767906449166901/019d08af-2abe-76c9-a27e-b209ec7376e3.webp",
        "width": 1102,
        "height": 1280
      },
      "poi_business_url": "https://locations.in-n-out.com/276",
      "poi_directions_map_url": "https://maps.google.com/?cid=4866440018724358803&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.5980167",
      "poi_longitude": "-121.4194193",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc6e-7414-8fa5-725df0c342d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc6e-7414-8fa5-725df0c342d4",
        "storage_key": "property/6767906449166901/019d08ae-cc6e-7414-8fa5-725df0c342d4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ6ToLSPamoARk4rP3GkRiUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_000d3c05-df21-4384-bc6e-a522925f00b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2101 Alta Arden Expy, Sacramento, CA 95825, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant offers delicious chicken sandwiches, salads, and shakes. They also highlight the friendly staff, fast service, and clean atmosphere.\n\nOther reviews mention orders can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-2a69-7728-a4f6-24e74638279e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-2a69-7728-a4f6-24e74638279e",
        "storage_key": "property/6767906449166901/019d08af-2a69-7728-a4f6-24e74638279e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ca/arden-fair?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=15156801471129607094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "38.5987882",
      "poi_longitude": "-121.4174906",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-922-2814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc6e-7414-8fa5-725df0c342d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc6e-7414-8fa5-725df0c342d4",
        "storage_key": "property/6767906449166901/019d08ae-cc6e-7414-8fa5-725df0c342d4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Sz6ViPamoARtlvMQaLGV9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_a11b015e-40e0-4a4c-9b81-4d494a2135b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Tower Café",
      "poi_type": "Restaurants",
      "poi_address": "1518 Broadway, Sacramento, CA 95818, USA",
      "poi_short_description": "Quirky cafe serving an eclectic array of grub, from classic breakfasts to Asian and Spanish mains.",
      "poi_long_description": "People say this restaurant serves delicious French toast, Thai steak and eggs, and salads. They highlight the large portions, diverse menu, and beautiful outdoor seating area with fountains and lush greenery. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-2aa1-7019-ac87-c462f2feecf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-2aa1-7019-ac87-c462f2feecf6",
        "storage_key": "property/6767906449166901/019d08af-2aa1-7019-ac87-c462f2feecf6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.towercafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17467647007537499128&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tower-caf",
      "poi_latitude": "38.5616745",
      "poi_longitude": "-121.4935217",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-441-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc6e-7414-8fa5-725df0c342d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc6e-7414-8fa5-725df0c342d4",
        "storage_key": "property/6767906449166901/019d08ae-cc6e-7414-8fa5-725df0c342d4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM4Wmdx7RmoAR-Asw4meMafI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bc137c4a-c33e-441a-ad30-14ef76641f20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Drake's: The Barn",
      "poi_type": "Restaurants",
      "poi_address": "985 Riverfront St, West Sacramento, CA 95691, USA",
      "poi_short_description": "Outdoor gathering place with a beer garden, pizzeria & 3 stages hosting DJs & live music shows.",
      "poi_long_description": "People say this beer garden offers a great selection of beers, delicious pizzas, and burgers. They highlight the fun, energetic, and lively atmosphere, and the spacious outdoor seating with fire pits. They also like that it's dog-friendly and family-friendly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-2b1f-76cc-8575-d5e24832c32d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-2b1f-76cc-8575-d5e24832c32d",
        "storage_key": "property/6767906449166901/019d08af-2b1f-76cc-8575-d5e24832c32d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://drinkdrakes.com/places/the-barn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4212264906490894141&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "drakes-the-barn",
      "poi_latitude": "38.574851",
      "poi_longitude": "-121.514729",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-723a-73db-9877-fe87fbac314e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-723a-73db-9877-fe87fbac314e",
        "storage_key": "property/6767906449166901/019d08af-723a-73db-9877-fe87fbac314e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIzOrD0rRmoARPdc7a534dDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_8ae491a7-c45f-49f0-a782-71eaddf82d37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Urban Roots Brewery & Smokehouse",
      "poi_type": "Restaurants",
      "poi_address": "1322 V St, Sacramento, CA 95818, USA",
      "poi_short_description": "Stylish indoor-outdoor joint serving a wide variety of housemade beers alongside hearty BBQ fare.",
      "poi_long_description": "People say this brewpub serves delicious brisket, burnt ends, and BBQ turkey, and offers a variety of tasty sides. They highlight the generous portions, the self-serve BBQ sauce bar with three different sauces, and the friendly staff. They also like the fun, laid-back atmosphere, with both indoor and outdoor seating, and the extensive selection of craft beers and ciders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-304d-70d9-94d6-f3ef9bac8375.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-304d-70d9-94d6-f3ef9bac8375",
        "storage_key": "property/6767906449166901/019d08af-304d-70d9-94d6-f3ef9bac8375.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.urbanrootsbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=322330605051558123&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-roots-brewery--smokehouse",
      "poi_latitude": "38.5655783",
      "poi_longitude": "-121.4941211",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-706-3741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-723a-73db-9877-fe87fbac314e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-723a-73db-9877-fe87fbac314e",
        "storage_key": "property/6767906449166901/019d08af-723a-73db-9877-fe87fbac314e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI6W_gh_RmoAR67hVPvoleQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_f60d9f11-5a30-4448-b45b-62d5b2e67f3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Arden Fair",
      "poi_type": "Shopping & Retail",
      "poi_address": "1689 Arden Way, Sacramento, CA 95815, USA",
      "poi_short_description": "Bright, spacious mall featuring 150+ shops, a food court with fast food & full-service restaurants.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including clothing, shoes, and tech, as well as a large food court with diverse options. They also highlight the clean and well-maintained environment, and the presence of security.\n\nOther reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-30c3-70d9-8f0f-162aecd22569.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-30c3-70d9-8f0f-162aecd22569",
        "storage_key": "property/6767906449166901/019d08af-30c3-70d9-8f0f-162aecd22569.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ardenfair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15499193860254925598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arden-fair",
      "poi_latitude": "38.6011646",
      "poi_longitude": "-121.4276086",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-920-1167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-d33f-757c-860c-128cd9a8c380.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-d33f-757c-860c-128cd9a8c380",
        "storage_key": "property/6767906449166901/019d08ae-d33f-757c-860c-128cd9a8c380.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLwm9mh7amoARHgNpmbIyGNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_36e23194-fcae-4568-94a2-4c3a2ef69d94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "700 Ikea Ct, West Sacramento, CA 95605, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide variety of products, including beds, home decor, and Swedish meatballs. They also highlight the reasonable prices, clean and organized environment, and friendly staff.\n\nSome reviews mention the food court can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-30fa-7669-a18c-ec8ffe1cf369.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-30fa-7669-a18c-ec8ffe1cf369",
        "storage_key": "property/6767906449166901/019d08af-30fa-7669-a18c-ec8ffe1cf369.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/west-sacramento/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=west-sacramento",
      "poi_directions_map_url": "https://maps.google.com/?cid=1134161977023253649&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "38.58660769999999",
      "poi_longitude": "-121.5535253",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-d33f-757c-860c-128cd9a8c380.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-d33f-757c-860c-128cd9a8c380",
        "storage_key": "property/6767906449166901/019d08ae-d33f-757c-860c-128cd9a8c380.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzyahGxSo6lQRkcw5Hk9avQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_9929cb36-691d-4511-994f-3f51a835b9e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 Folsom Blvd, Sacramento, CA 95819, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique, healthy, and organic foods, including fresh produce, snacks, and frozen meals. They highlight the reasonable prices, especially for flowers and cheese, and the friendly, helpful staff. They also like the well-stocked aisles and the clean, organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-3185-7472-8f5b-838cb75d24d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-3185-7472-8f5b-838cb75d24d4",
        "storage_key": "property/6767906449166901/019d08af-3185-7472-8f5b-838cb75d24d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/sacramento/175/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5778462611759847179&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.5603947",
      "poi_longitude": "-121.4448167",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-456-1853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc6f-73f0-b91e-90dd050f9f26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc6f-73f0-b91e-90dd050f9f26",
        "storage_key": "property/6767906449166901/019d08ae-cc6f-73f0-b91e-90dd050f9f26.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRh5PYDamoARC1fSOSE5MVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a9ccfaf6-b836-4d9c-b728-6097e1cf6204",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Sacramento Natural Foods Co-op",
      "poi_type": "Shopping & Retail",
      "poi_address": "2820 R St, Sacramento, CA 95816, USA",
      "poi_short_description": "Sustainably minded market for seasonal, organic produce as well as meats, fish & specialty foods.",
      "poi_long_description": "People say this grocery store offers a wide variety of natural, organic, and local products, including fresh produce, bulk items, and prepared foods. They highlight the clean, well-organized layout, and the convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-361c-71a4-b9f3-ab967cd870fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-361c-71a4-b9f3-ab967cd870fb",
        "storage_key": "property/6767906449166901/019d08af-361c-71a4-b9f3-ab967cd870fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sac.coop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15451927587609601651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-natural-foods-co-op",
      "poi_latitude": "38.5645864",
      "poi_longitude": "-121.4725986",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-455-2667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc6f-73f0-b91e-90dd050f9f26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc6f-73f0-b91e-90dd050f9f26",
        "storage_key": "property/6767906449166901/019d08ae-cc6f-73f0-b91e-90dd050f9f26.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXyB2vvLQmoARc2aH6kVGcNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b6be0244-063f-4c20-91b0-33626a273a5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1814 19th St, Sacramento, CA 95811, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "People say this grocery store offers a wide variety of items, including fresh produce, prepared meals, and a deli section with sandwiches. They also highlight the friendly and helpful staff, the clean and well-maintained facility, and the convenient location with ample parking.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://local.safeway.com/safeway/ca/sacramento/1814-19th-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=9086144474484919629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "38.5679278",
      "poi_longitude": "-121.4860899",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-492-9967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc6f-73f0-b91e-90dd050f9f26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc6f-73f0-b91e-90dd050f9f26",
        "storage_key": "property/6767906449166901/019d08ae-cc6f-73f0-b91e-90dd050f9f26.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_q7ruDQmoARTU2NU0J4GH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_105e85a4-4db6-46e6-82e5-4d23571bf868",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "California State University, Sacramento",
      "poi_type": "Education",
      "poi_address": "6000 Jed Smith Dr, Sacramento, CA 95819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-c35b-77aa-8927-02f12c070017.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-c35b-77aa-8927-02f12c070017",
        "storage_key": "property/6767906449166901/019d08ae-c35b-77aa-8927-02f12c070017.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://csus.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8520208179546512258&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-university-sacramento",
      "poi_latitude": "38.560824",
      "poi_longitude": "-121.423993",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 916-278-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-d33f-757c-860c-0d49c609a64a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-d33f-757c-860c-0d49c609a64a",
        "storage_key": "property/6767906449166901/019d08ae-d33f-757c-860c-0d49c609a64a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2_TGMY3amoARgls_gjLcPXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a6090850-144f-4b79-85b5-ac3768ee02b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Sacramento City College",
      "poi_type": "Education",
      "poi_address": "3835 Freeport Blvd, Sacramento, CA 95822, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-36d1-7436-8e7d-b48768ef4a2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-36d1-7436-8e7d-b48768ef4a2e",
        "storage_key": "property/6767906449166901/019d08af-36d1-7436-8e7d-b48768ef4a2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.scc.losrios.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=530924599920790724&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-city-college",
      "poi_latitude": "38.5410812",
      "poi_longitude": "-121.4879724",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-558-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-d33f-757c-860c-0d49c609a64a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-d33f-757c-860c-0d49c609a64a",
        "storage_key": "property/6767906449166901/019d08ae-d33f-757c-860c-0d49c609a64a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIaIDi03QmoARxIzLVBw5Xgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f11c6ee3-e103-4c6f-89c0-107d192fdfa1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "California State University, Sacramento - University Library",
      "poi_type": "Education",
      "poi_address": "2000 State University Dr, Sacramento, CA 95819, USA",
      "poi_short_description": "University library stocking 1.4 million volumes of books, literature and films, as well as computers and charging stations.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-37fc-755d-b339-16714e1b6bdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-37fc-755d-b339-16714e1b6bdd",
        "storage_key": "property/6767906449166901/019d08af-37fc-755d-b339-16714e1b6bdd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://library.csus.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4601398765764040304&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-university-sacramento---university-library",
      "poi_latitude": "38.5595419",
      "poi_longitude": "-121.4236427",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 916-278-5679",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-e451-72bc-9785-a4ce3a2156f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e451-72bc-9785-a4ce3a2156f0",
        "storage_key": "property/6767906449166901/019d08ae-e451-72bc-9785-a4ce3a2156f0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn12DOI3amoARcFZJV8xz2z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_1baae800-d939-44fb-ac46-2b649353486f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Golden 1 Center",
      "poi_type": "Entertainment",
      "poi_address": "500 David J Stern Walk, Sacramento, CA 95814, USA",
      "poi_short_description": "Modern venue built for basketball games, concerts and events, featuring a vegan food station.",
      "poi_long_description": "People say this arena offers a variety of drinks and snacks, and hosts concerts and basketball games. They highlight the comfortable seating, modern design, and excellent sound and video quality. They also like the friendly and helpful staff, and the convenient location with nearby parking and restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-5dd6-7419-9497-9dec0e4b74ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-5dd6-7419-9497-9dec0e4b74ba",
        "storage_key": "property/6767906449166901/019d08ae-5dd6-7419-9497-9dec0e4b74ba.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.golden1center.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10987748936193945510&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-1-center",
      "poi_latitude": "38.5802045",
      "poi_longitude": "-121.4996602",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 888-915-4647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxlrBLxM6IARpi8EH3FTfJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_617bf219-92fd-45e3-9d6a-4c679fa5a1ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Sutter Health Park",
      "poi_type": "Entertainment",
      "poi_address": "400 Ballpark Dr, West Sacramento, CA 95691, USA",
      "poi_short_description": "Outdoor baseball field features regular sports games, concerts & events, with on-site concessions.",
      "poi_long_description": "People say this stadium offers a variety of seating options, including lawn seats, and has a fun atmosphere with fireworks and activities between innings. They highlight the friendly staff, clean facilities, and the opportunity to see both minor and major league baseball games. They also like the convenient parking and easy access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-3adb-774c-9f12-d3dca31c167c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-3adb-774c-9f12-d3dca31c167c",
        "storage_key": "property/6767906449166901/019d08af-3adb-774c-9f12-d3dca31c167c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sutterhealthpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2722204505153287407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutter-health-park",
      "poi_latitude": "38.5798114",
      "poi_longitude": "-121.5147519",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-376-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-7595-73c3-88bb-24e6d44fd5d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7595-73c3-88bb-24e6d44fd5d7",
        "storage_key": "property/6767906449166901/019d08af-7595-73c3-88bb-24e6d44fd5d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnalemcrWmoAR7zShF5M2xyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e82b2b8d-6928-4610-afb0-00ef9ac5e9a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Sacramento Zoo",
      "poi_type": "Entertainment",
      "poi_address": "3930 W Land Park Dr, Sacramento, CA 95822, USA",
      "poi_short_description": "Longtime, 14-acre animal park housing native & endangered species, plus a giraffe encounter exhibit.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including big cats, red pandas, and flamingos, and provides opportunities for giraffe feeding and a carousel ride. They also highlight the active animals, well-maintained habitats, and the friendly and knowledgeable staff.\n\nOther reviews mention the zoo can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-6782-779c-a2a9-eb57aaae610f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-6782-779c-a2a9-eb57aaae610f",
        "storage_key": "property/6767906449166901/019d08ae-6782-779c-a2a9-eb57aaae610f.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://saczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6430915052866730629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-zoo",
      "poi_latitude": "38.5392791",
      "poi_longitude": "-121.5040041",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-808-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0nl36XRmoARhXrVCiszP1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_6eb61fd1-690d-4647-a163-c7fd0e1ef9d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "California State Railroad Museum",
      "poi_type": "Entertainment",
      "poi_address": "125 I St, Sacramento, CA 95814, USA",
      "poi_short_description": "Colorful museum documenting railroad history via vintage locomotives, exhibits & rides.",
      "poi_long_description": "People say this rail museum offers a collection of locomotives, train cars, and model trains, as well as interactive exhibits and a play area. They highlight the intimate setting, beautiful candlelight concerts, and the friendly and knowledgeable staff and volunteers. They also like the informative signs and the opportunity to explore inside some of the train cars. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-6307-716b-bcaa-41432cce7ba4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-6307-716b-bcaa-41432cce7ba4",
        "storage_key": "property/6767906449166901/019d08ae-6307-716b-bcaa-41432cce7ba4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.californiarailroad.museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13064911033240821480&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-railroad-museum",
      "poi_latitude": "38.5849368",
      "poi_longitude": "-121.5044161",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-323-9280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-d432-7578-8af4-d9fd304b83ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-d432-7578-8af4-d9fd304b83ca",
        "storage_key": "property/6767906449166901/019d08ae-d432-7578-8af4-d9fd304b83ca.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJYxCsn83WmoAR6J5mJl3jT7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3f5eb0d7-00b7-46db-947c-08e42b206434",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "California State Capitol Museum",
      "poi_type": "Entertainment",
      "poi_address": "1315 10th St, Sacramento, CA 95814, USA",
      "poi_short_description": "Elegant, long-standing museum documenting the history of California via exhibits, artifacts & more.",
      "poi_long_description": "Visitors say this history museum offers free tours, a gift shop, and impressive architecture. They also highlight the knowledgeable and friendly tour guides, and the clean and well-maintained building and grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-ad40-733d-bb47-14d402ed38bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-ad40-733d-bb47-14d402ed38bc",
        "storage_key": "property/6767906449166901/019d08ae-ad40-733d-bb47-14d402ed38bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.capitolmuseum.ca.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=378875291323442389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-capitol-museum",
      "poi_latitude": "38.5765882",
      "poi_longitude": "-121.4932368",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-324-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-d432-7578-8af4-d9fd304b83ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-d432-7578-8af4-d9fd304b83ca",
        "storage_key": "property/6767906449166901/019d08ae-d432-7578-8af4-d9fd304b83ca.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJldtsqgTWmoAR1aSB8REJQgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_dd993ab9-90a2-4264-aa9f-b6af90803c2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1020 7th St, Sacramento, CA 95814, USA",
      "poi_short_description": "Spacious fitness center with cardio machines, weight areas, basketball courts and a pool.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including cardio machines, free weights, and a basketball court, as well as amenities like a sauna, steam room, and hot tub. They also highlight the convenient parking, the welcoming and friendly staff, and the positive and uplifting atmosphere.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-3fd8-715d-ade8-2a2e2686492b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-3fd8-715d-ade8-2a2e2686492b",
        "storage_key": "property/6767906449166901/019d08af-3fd8-715d-ade8-2a2e2686492b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/sacramento-ca/downtown-sacramento-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=4640322691779290524&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.5808218",
      "poi_longitude": "-121.4983842",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-658-1626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQN3eyzRmoARnGWwFue8ZUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1b131fb2-508f-48ac-9fc1-16bad858d07e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4750 Natomas Blvd, Sacramento, CA 95835, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of machines and equipment, including cardio, resistance training, and free weights. They also highlight the clean and well-maintained facilities, and the friendly and helpful staff.\n\nOther reviews mention it can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-426f-75e7-ac4d-8ae3ed1682fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-426f-75e7-ac4d-8ae3ed1682fb",
        "storage_key": "property/6767906449166901/019d08af-426f-75e7-ac4d-8ae3ed1682fb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/natomas-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=14646428136180834555&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.659707",
      "poi_longitude": "-121.5095647",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-857-8630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp9tzs3wpm4AR-2BYLcqQQss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1a5b9a03-b8ae-44dd-aa5e-df3aa43c64ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "In-Shape Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3880 Innovator Dr, Sacramento, CA 95834, USA",
      "poi_short_description": "Family-friendly fitness center offering an indoor and outdoor pool plus a kids' zone and climbing wall.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, indoor and outdoor pools, and a kids' splash area.\n\nOther reviews mention the facilities can be poorly maintained and some machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-43ad-7709-a3f9-8151791da113.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-43ad-7709-a3f9-8151791da113",
        "storage_key": "property/6767906449166901/019d08af-43ad-7709-a3f9-8151791da113.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.inshape.com/gyms/natomas?utm_source=G&utm_medium=Local&utm_campaign=Google-Local&utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1974938444105111114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-shape-fitness",
      "poi_latitude": "38.639569",
      "poi_longitude": "-121.5083534",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-239-4455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSiAMj_WmoARStYlHg1kaBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_991a7c2b-ddf1-4f91-a280-7fd26bb368fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "City Sports Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3580 Crocker Dr, Sacramento, CA 95818, USA",
      "poi_short_description": "",
      "poi_long_description": "Some gym goers say this gym offers a wide variety of well-maintained machines, a clean facility, and friendly, helpful staff. \n\nOther reviews mention the gym can be crowded and membership cancellation can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-46f0-71ed-bce5-962eebed9bc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-46f0-71ed-bce5-962eebed9bc4",
        "storage_key": "property/6767906449166901/019d08af-46f0-71ed-bce5-962eebed9bc4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.citysportsfitness.com/Pages/clubhome.aspx?clubid=1312&",
      "poi_directions_map_url": "https://maps.google.com/?cid=13663868868192490960&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-sports-club",
      "poi_latitude": "38.54227789999999",
      "poi_longitude": "-121.4838807",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-246-1636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJffwWZuPRmoAR0NUhYlfQn70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_71100f9d-a9b3-4bb3-8d4a-5fcb3cfd50a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "The WELL",
      "poi_type": "Health and Wellness",
      "poi_address": "6000 J St, Sacramento, CA 95819, USA",
      "poi_short_description": "Modern, spacious, on-campus gym featuring weight machines, classes, basketball and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-4897-719d-9761-8c09937ba3cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4897-719d-9761-8c09937ba3cb",
        "storage_key": "property/6767906449166901/019d08af-4897-719d-9761-8c09937ba3cb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thewellatsacstate.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5612426490005051286&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-well",
      "poi_latitude": "38.5569669",
      "poi_longitude": "-121.4235304",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 916-278-9355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOUeFxZLamoARlle-IChY400",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_80960981-40d8-4bc7-bdcf-b9fd37e2078a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Crunch Fitness - Market Square",
      "poi_type": "Health and Wellness",
      "poi_address": "1739 Arden Way, Sacramento, CA 95815, USA",
      "poi_short_description": "Membership-only gym at Market Square at Arden Fair offering group classes and personal trainers.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and classes. They also highlight the clean facilities, friendly staff, and welcoming atmosphere.\n\nOther reviews mention the membership can be difficult to cancel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-49c1-72d2-b3e2-3dbb2df2ab0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-49c1-72d2-b3e2-3dbb2df2ab0a",
        "storage_key": "property/6767906449166901/019d08af-49c1-72d2-b3e2-3dbb2df2ab0a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.crunch.com/locations/marketsquare",
      "poi_directions_map_url": "https://maps.google.com/?cid=17728157417301185125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---market-square",
      "poi_latitude": "38.5994681",
      "poi_longitude": "-121.4232353",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-913-2260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZ8uG_3bmoARZZJxRD4RB_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2b7bbd72-1e04-4dc8-be4a-35af33eaceac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Sacramento Central YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2021 W St, Sacramento, CA 95818, USA",
      "poi_short_description": "Community fitness center with a swimming pool and classes, plus programs for children.",
      "poi_long_description": "People say this gym offers a variety of workout equipment, group exercise classes, and a large, heated indoor pool. They also highlight the friendly and helpful staff, the welcoming and inclusive atmosphere, and the clean facilities.\n\nOther reviews mention the facilities can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-4aac-71ee-91a9-c6e2d4bbd831.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4aac-71ee-91a9-c6e2d4bbd831",
        "storage_key": "property/6767906449166901/019d08af-4aac-71ee-91a9-c6e2d4bbd831.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "http://www.ymcasuperiorcal.org/sacramentoymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=5417990014250751205&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-central-ymca",
      "poi_latitude": "38.5623639",
      "poi_longitude": "-121.4855257",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-452-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTUhHi-PQmoAR5ZQHVDaRMEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3e366dc7-b40c-4d2d-a294-b33725a1db9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "UC Davis Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4301 X St, Sacramento, CA 95817, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-6d9e-75fb-9e73-adf705228369.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-6d9e-75fb-9e73-adf705228369",
        "storage_key": "property/6767906449166901/019d08ae-6d9e-75fb-9e73-adf705228369.webp",
        "width": 500,
        "height": 330
      },
      "poi_business_url": "https://health.ucdavis.edu/medicalcenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8899362877471555770&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uc-davis-medical-center",
      "poi_latitude": "38.5547656",
      "poi_longitude": "-121.4552827",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 916-734-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-dd50-71d9-89a4-86b44b7ce0bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-dd50-71d9-89a4-86b44b7ce0bd",
        "storage_key": "property/6767906449166901/019d08ae-dd50-71d9-89a4-86b44b7ce0bd.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJA4rq2nzQmoARuoD93mLjgHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1530d1b7-319c-423a-ae47-5af2c28c02e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Kaiser Permanente Sacramento Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2025 Morse Ave, Sacramento, CA 95825, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-b1d7-7761-aab1-309aa08a1a22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-b1d7-7761-aab1-309aa08a1a22",
        "storage_key": "property/6767906449166901/019d08ae-b1d7-7761-aab1-309aa08a1a22.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://healthy.kaiserpermanente.org/northern-california/facilities/Sacramento-Medical-Center-100330",
      "poi_directions_map_url": "https://maps.google.com/?cid=825758789253687625&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-sacramento-medical-center",
      "poi_latitude": "38.6021267",
      "poi_longitude": "-121.3924928",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-973-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-dd50-71d9-89a4-86b44b7ce0bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-dd50-71d9-89a4-86b44b7ce0bd",
        "storage_key": "property/6767906449166901/019d08ae-dd50-71d9-89a4-86b44b7ce0bd.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ24Jpp87bmoARSWmfZz6vdQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_8a2dbbd7-bee4-4035-8bc7-38166d208eb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Discovery Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Sacramento, CA 95833, USA",
      "poi_short_description": "302-acre park featuring a 32-mile bike trail, ball fields, picnic sites, fishing & boat launches.",
      "poi_long_description": "People say this park offers a boat launch, fishing, and picnic areas with barbecue grills and shade. They also highlight the spacious layout, the American River bike trail, and the beautiful views of the river confluence.\n\nSome reviews mention the park can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-8ca0-72f8-b58c-036d229ecdbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-8ca0-72f8-b58c-036d229ecdbe",
        "storage_key": "property/6767906449166901/019d08ae-8ca0-72f8-b58c-036d229ecdbe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://regionalparks.saccounty.net/Parks/Pages/DiscoveryPark.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6608359273538838528&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "discovery-park",
      "poi_latitude": "38.6057626",
      "poi_longitude": "-121.50348",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-875-6961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-dd5b-7068-ac3c-e41514e293c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-dd5b-7068-ac3c-e41514e293c7",
        "storage_key": "property/6767906449166901/019d08ae-dd5b-7068-ac3c-e41514e293c7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqjbDmoARAOBwJ7-btVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4a20613d-e332-4ac1-b3cd-810934aaf4c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "McKinley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 Alhambra Blvd, Sacramento, CA 95816, USA",
      "poi_short_description": "Relaxing preserve featuring a rose garden, seasonal pool, playgrounds, tennis courts & trails.",
      "poi_long_description": "Visitors say this park offers a relaxing atmosphere with a beautiful rose garden, perfect for long walks or jogs, and a pond where you can feed the ducks. They also highlight the well-maintained park, spacious for picnics, and fun for kids with a large playground and a nearby public pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-511a-709c-9c0e-1abc7b9dbda3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-511a-709c-9c0e-1abc7b9dbda3",
        "storage_key": "property/6767906449166901/019d08af-511a-709c-9c0e-1abc7b9dbda3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofsacramento.org/ParksandRec/Parks/Park-Directory/Central-City/McKinley-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9817515343663866372&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mckinley-park",
      "poi_latitude": "38.5768935",
      "poi_longitude": "-121.4630764",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-808-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-dd5b-7068-ac3c-e41514e293c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-dd5b-7068-ac3c-e41514e293c7",
        "storage_key": "property/6767906449166901/019d08ae-dd5b-7068-ac3c-e41514e293c7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb6sj4JfQmoARBCIIjDDSPog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_96db1d01-936a-4694-be89-428a1b48e2a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Haggin Oaks Golf Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3645 Fulton Ave, Sacramento, CA 95821, USA",
      "poi_short_description": "Historic golf complex featuring 2 18-hole courses, plus a driving range, a pro shop & an eatery.",
      "poi_long_description": "People say this golf course offers quality lessons, clean and well-maintained courses, and a huge driving range. They highlight the late-night driving range and food trucks, and the enjoyable experience of hitting balls and dining at the MacKenzie Grill. They also like the instructors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-51db-715f-bbfd-51a2a97f72b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-51db-715f-bbfd-51a2a97f72b6",
        "storage_key": "property/6767906449166901/019d08af-51db-715f-bbfd-51a2a97f72b6.webp",
        "width": 996,
        "height": 657
      },
      "poi_business_url": "https://www.hagginoaks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6467797662234953962&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haggin-oaks-golf-complex",
      "poi_latitude": "38.633561",
      "poi_longitude": "-121.4033421",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-808-2515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-791e-764d-bbae-198a2fb8f17a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-791e-764d-bbae-198a2fb8f17a",
        "storage_key": "property/6767906449166901/019d08af-791e-764d-bbae-198a2fb8f17a.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJz69Jx6HZmoAR6siduLQ7wlk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_51faff7a-971f-47f4-89d6-168f40f1dc54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "California State Capitol Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 L St, Sacramento, CA 95814, USA",
      "poi_short_description": "Scenic city green space with monuments, memorials, flower gardens & walking paths.",
      "poi_long_description": "People say this park offers beautiful gardens, exotic trees, and historic monuments, including a rose garden and memorials to veterans and firefighters. They highlight the peaceful and relaxing vibe, and the well-maintained grounds with clear signage. They also like that the park is dog-friendly and provides opportunities for learning about botany and history. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-525c-749b-a104-1ae41b06fd89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-525c-749b-a104-1ae41b06fd89",
        "storage_key": "property/6767906449166901/019d08af-525c-749b-a104-1ae41b06fd89.webp",
        "width": 640,
        "height": 853
      },
      "poi_business_url": "https://capitolmuseum.ca.gov/learn/about-the-capitol/capitol-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5243745298811035407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-capitol-park",
      "poi_latitude": "38.5759282",
      "poi_longitude": "-121.4907022",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-324-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-dd5b-7068-ac3c-e41514e293c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-dd5b-7068-ac3c-e41514e293c7",
        "storage_key": "property/6767906449166901/019d08ae-dd5b-7068-ac3c-e41514e293c7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuVIWBdjQmoARD59BFJGGxUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7ae76003-f0b7-47d0-80b1-0c39b0c08ab8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "State Capitol Park World Peace Rose Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1317 15th St, Sacramento, CA 95814, USA",
      "poi_short_description": "Peace-themed Victorian style rose garden within a park, with a fountain & pavilion.",
      "poi_long_description": "Visitors say this rose garden offers a tranquil experience with hundreds of varieties of roses in bloom, as well as trees from all over the world. They also highlight the well-maintained park, peaceful atmosphere, and educational value of the different rose species.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-52a6-762e-b119-30e5b7ad7f82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-52a6-762e-b119-30e5b7ad7f82",
        "storage_key": "property/6767906449166901/019d08af-52a6-762e-b119-30e5b7ad7f82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://worldpeacerosegardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1381262157938595809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "state-capitol-park-world-peace-rose-garden",
      "poi_latitude": "38.575501",
      "poi_longitude": "-121.4883327",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-381-5433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-dd5b-7068-ac3c-e41514e293c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-dd5b-7068-ac3c-e41514e293c7",
        "storage_key": "property/6767906449166901/019d08ae-dd5b-7068-ac3c-e41514e293c7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_Yds9nQmoAR4ZeeSZ06KxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_60e90661-63ff-4c64-ae21-35eb6d383ee2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Sacramento McClellan Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3028 Peacekeeper Way, McClellan Park, CA 95652, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-57b1-72cb-9cfa-f0900f20a353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-57b1-72cb-9cfa-f0900f20a353",
        "storage_key": "property/6767906449166901/019d08af-57b1-72cb-9cfa-f0900f20a353.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://sacramentomcclellanairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16063768450761385839&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-mcclellan-airport",
      "poi_latitude": "38.6594179",
      "poi_longitude": "-121.3955482",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-570-5317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-dd59-704b-9560-9f533b9bc4c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-dd59-704b-9560-9f533b9bc4c6",
        "storage_key": "property/6767906449166901/019d08ae-dd59-704b-9560-9f533b9bc4c6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJNylN3PPYmoARb2fC5Uv47d4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_7b9d19ce-dda9-48a8-8718-1a71beb33879",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "University/65th Street Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-58a2-7409-8457-b558268552d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-58a2-7409-8457-b558268552d7",
        "storage_key": "property/6767906449166901/019d08af-58a2-7409-8457-b558268552d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3002021551157189183&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university65th-street-station-wb",
      "poi_latitude": "38.55265",
      "poi_longitude": "-121.42749",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ77gV9pPamoARP5rKBLJSqSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_4d08b710-30ba-4e8b-a662-e0383b0fab53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Sacramento Valley Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-5913-77df-ac55-64fbe33bcabc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-5913-77df-ac55-64fbe33bcabc",
        "storage_key": "property/6767906449166901/019d08af-5913-77df-ac55-64fbe33bcabc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6346517780329793861&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-valley-station-wb",
      "poi_latitude": "38.584627",
      "poi_longitude": "-121.500439",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncYA5dLWmoARRQlCwUtcE1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_e112bf70-ff4c-4a79-b144-eb60ba5af7d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Arden/Del Paso Station (EB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95815, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-5b14-76ac-b7c8-d1b664b0f903.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-5b14-76ac-b7c8-d1b664b0f903",
        "storage_key": "property/6767906449166901/019d08af-5b14-76ac-b7c8-d1b664b0f903.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=567876029887657118&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ardendel-paso-station-eb",
      "poi_latitude": "38.606207",
      "poi_longitude": "-121.456274",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd59FpVrXmoARnrTpjT2A4Qc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_1753a12e-f436-455a-92b3-76ae4c6a767f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "7th & Capitol",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-5fb7-74df-a150-f001a3c675ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-5fb7-74df-a150-f001a3c675ae",
        "storage_key": "property/6767906449166901/019d08af-5fb7-74df-a150-f001a3c675ae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5048847390555747041&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "7th--capitol",
      "poi_latitude": "38.5783062",
      "poi_longitude": "-121.4989023",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTq-mS7RmoAR4bI7p_MbEUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_a3daf4c6-7e5a-4369-b548-6b4fb01898fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Sacramento City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "915 I St, Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-5f44-7172-9264-2043555c8cb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-5f44-7172-9264-2043555c8cb7",
        "storage_key": "property/6767906449166901/019d08af-5f44-7172-9264-2043555c8cb7.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.cityofsacramento.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5261544109164931557&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-city-hall",
      "poi_latitude": "38.5823421",
      "poi_longitude": "-121.4933431",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-264-5011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-e451-72bc-9785-a4ce3a2156f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e451-72bc-9785-a4ce3a2156f0",
        "storage_key": "property/6767906449166901/019d08ae-e451-72bc-9785-a4ce3a2156f0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9NSRSrRmoAR5SnTjH3CBEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_bca810e9-963c-4860-add2-ad969d785ab2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Blue Diamond Growers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1802 C St, Sacramento, CA 95811, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-5fed-73ee-80d1-8b958b6b56cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-5fed-73ee-80d1-8b958b6b56cc",
        "storage_key": "property/6767906449166901/019d08af-5fed-73ee-80d1-8b958b6b56cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bluediamondgrowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16247972805344263985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-diamond-growers",
      "poi_latitude": "38.5857959",
      "poi_longitude": "-121.4810041",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-442-0771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7CwctLQmoARMX_AVi5lfOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e2395f4a-909f-4745-afa4-6ac4f5919d3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "City of West Sacramento City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1110 W Capitol Ave, West Sacramento, CA 95691, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-63ed-744f-b81a-cd92473552b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-63ed-744f-b81a-cd92473552b8",
        "storage_key": "property/6767906449166901/019d08af-63ed-744f-b81a-cd92473552b8.webp",
        "width": 1280,
        "height": 808
      },
      "poi_business_url": "http://www.cityofwestsacramento.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5233966858684488344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-west-sacramento-city-hall",
      "poi_latitude": "38.58203210000001",
      "poi_longitude": "-121.5234091",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-617-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-e451-72bc-9785-a4ce3a2156f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-e451-72bc-9785-a4ce3a2156f0",
        "storage_key": "property/6767906449166901/019d08ae-e451-72bc-9785-a4ce3a2156f0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcUyoorHWmoARmFoOkiDJokg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_873a48ed-e141-491e-bce9-00ac04901654",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Resources Building - State of California",
      "poi_type": "Major Employers & Offices",
      "poi_address": "715 P St, Sacramento, CA 95814, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-67e7-754b-9c54-05cb6b6e734a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-67e7-754b-9c54-05cb6b6e734a",
        "storage_key": "property/6767906449166901/019d08af-67e7-754b-9c54-05cb6b6e734a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://resources.ca.gov/About-Us/our-new-headquarters",
      "poi_directions_map_url": "https://maps.google.com/?cid=13310981311370573820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "resources-building---state-of-california",
      "poi_latitude": "38.5752007",
      "poi_longitude": "-121.4993404",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-367-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH9oPNi_RmoAR_DcbZPoaurg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_490b2375-77f5-4518-88bc-92a9a63c473f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "poi_name": "Centene Campus Natomas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4201 E Commerce Way, Sacramento, CA 95834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08af-684d-73e5-9536-2b497a30edc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-684d-73e5-9536-2b497a30edc1",
        "storage_key": "property/6767906449166901/019d08af-684d-73e5-9536-2b497a30edc1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.centene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9616052681257976114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "centene-campus-natomas",
      "poi_latitude": "38.6466286",
      "poi_longitude": "-121.5240407",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 314-725-4477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-cc7c-7488-8223-d4e35321ae63",
        "storage_key": "property/6767906449166901/019d08ae-cc7c-7488-8223-d4e35321ae63.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaddcK4jXmoARMgHTL_cUc4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_aeac55e4-b788-4e4e-99cf-daeec194a679",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_f09fa69a-6c13-4d88-82dc-8d685a3b0e95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_12fb4e49-6b5d-4f99-a416-32442a592fa6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_10f6238e-1f66-4a3e-bc20-b5bbcf54437f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_e8d4e148-9d06-4406-bf41-c2f677cd5aed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_8e464b86-df5f-4f1f-a5e6-28a3feeb7be9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_d8dd6716-d4af-43f3-8d93-2460a69022bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "rating": "5.0",
      "name": "Calvin Saetern",
      "text": "Trying to find the right place for my mom was hard, but the management team here was awesome and helped a ton with the questions I had and helped me with every step of the way until I was able to get her all moved in. Thank you",
      "date": "2025-06-03",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_158ca16a-dc6f-40a1-a824-ab1a9964ad3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d2c37-7bf4-719d-abb5-ffbfea922424.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c37-7bf4-719d-abb5-ffbfea922424",
        "storage_key": "property/6767906449166901/019d2c37-7bf4-719d-abb5-ffbfea922424.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pheasant Pointe Apartments  - 1 Bedroom 1 Bath 680 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=6KAznNCLsBD"
    },
    {
      "id": "custom_20561c12-12d0-4bb4-9b43-7aea9df37769",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d2c37-9bfd-703f-9452-52d55293ca3e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c37-9bfd-703f-9452-52d55293ca3e",
        "storage_key": "property/6767906449166901/019d2c37-9bfd-703f-9452-52d55293ca3e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pheasant Pointe Apartments - 2 Bedroom 2 Bath 887 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zjHfoKMWuTW"
    },
    {
      "id": "custom_505294dd-b44c-4a06-ae1c-c4f67489e798",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d2c37-bac2-7386-8285-cc18967aaa02.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c37-bac2-7386-8285-cc18967aaa02",
        "storage_key": "property/6767906449166901/019d2c37-bac2-7386-8285-cc18967aaa02.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pheasant Pointe Apartments  - 2 Bedroom 2 Bath 926 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cqodii88GmZ"
    },
    {
      "id": "custom_841bc1b8-9efc-4c00-b2fd-16994a9a22dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d2c37-dc50-768d-85b9-ef849ad45787.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c37-dc50-768d-85b9-ef849ad45787",
        "storage_key": "property/6767906449166901/019d2c37-dc50-768d-85b9-ef849ad45787.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pheasant Pointe Apartments - Pool & Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=J67pecjLw6o"
    },
    {
      "id": "custom_d0d3bfa6-d22c-4caf-822a-85c03bedc2ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d2c37-ff60-7771-91f0-edf1b925986a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c37-ff60-7771-91f0-edf1b925986a",
        "storage_key": "property/6767906449166901/019d2c37-ff60-7771-91f0-edf1b925986a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pheasant Pointe Apartments - Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Vv76Nqqycq3"
    },
    {
      "id": "custom_b57128ae-4f75-493a-89da-e613f7676f62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166901/019d2c38-1db4-741b-8d05-2f2892e75df9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c38-1db4-741b-8d05-2f2892e75df9",
        "storage_key": "property/6767906449166901/019d2c38-1db4-741b-8d05-2f2892e75df9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pheasant Pointe Apartments - Office",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hDnk1Xu5A7C"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1b7-4ecb-75b9-879e-9c9baf42a249",
      "lead_source": "LANDING_PAGE",
      "name": "Pheasant Pointe Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "generator",
      "page_item_url": "sacramento-apartments-in-unit-laundry-pheasant-pointe",
      "search_query": "sacramento apartments with in unit laundry",
      "category": "Amenity",
      "h1_title": "Sacramento Apartments with In Unit Laundry",
      "h2_subtitle": "Experience the convenience of in-unit laundry facilities at Pheasant Pointe. Perfectly located in North Sacramento for easy urban living.",
      "page_copy": "Discover comfortable living at Pheasant Pointe, where Sacramento apartments with in unit laundry offer a blend of convenience and modern amenities. Located in North Sacramento, our community is thoughtfully designed to enhance your lifestyle. Enjoy the warmth of a cozy fireplace in each unit after a busy day or spend time on your private patio soaking in the Californian sun.\n\nOur community stands out with features like Wi-Fi access and a dedicated property manager on site, ensuring a seamless living experience. Located in North Sacramento, Pheasant Pointe is not just a place to live, but a community nourishing you with planned social activities that foster connections. Revel in the comfort and ease of in-unit laundry facilities, making laundry day effortless and freeing up more time for what you love.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sacramento Apartments with In-Unit Laundry",
      "seo_description": "Enjoy in-unit laundry in Sacramento at Pheasant Pointe. Located in North Sacramento, we offer modern amenities and planned social activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-north-sacramento",
      "search_query": "pet friendly apartments in north sacramento with dog park",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Dog Park",
      "h2_subtitle": "Pheasant Pointe offers pet-friendly apartments in North Sacramento. Enjoy a vibrant community and a dedicated dog park for your furry friend.",
      "page_copy": "Welcome to Pheasant Pointe, where you'll find pet friendly apartments in North Sacramento with a dog park designed for you and your furry companion. Nestled in the heart of North Sacramento, our community is perfect for pet lovers looking for a balanced lifestyle that accommodates their pets' needs.\n\nOur apartments boast modern amenities like Wi-Fi and cozy fireplaces, offering comfort and convenience. The on-site dog park is ideal for letting your dog run and socialize with its four-legged friends. With planned social activities, meet other pet owners in the community and build lasting connections. Make Pheasant Pointe your new home, where pet-friendly living and vibrant community life harmoniously blend.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments with Dog Park",
      "seo_description": "Pheasant Pointe offers pet-friendly living in North Sacramento, complete with a dog park and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "generator",
      "page_item_url": "apartments-with-pool-sacramento-county-pheasant-pointe",
      "search_query": "apartments with a pool sacramento county",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Sacramento County",
      "h2_subtitle": "Discover serene living at Pheasant Pointe, where our Sacramento County apartments feature a refreshing pool and modern conveniences.",
      "page_copy": "At Pheasant Pointe in North Sacramento, experience the luxury of apartments with a pool where relaxation meets vibrant living. Set amidst Sacramento County's lively neighborhoods, enjoy unwinding by our beautiful pool after a long day.\n\nOur community offers more than just relaxation; with planned social activities and a dedicated property manager on site, you'll find it easy to connect with neighbors and create lasting friendships. Inside our spacious units, you'll find a cozy fireplace and private patio for additional comfort. Dive into a refreshing lifestyle at Pheasant Pointe, where the pool and community amenities enhance every aspect of your daily life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Sacramento County",
      "seo_description": "Relax by the pool at Pheasant Pointe. Located in Sacramento County, our community offers the best in comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "generator",
      "page_item_url": "sacramento-ca-apartments-air-conditioning",
      "search_query": "sacramento ca apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Sacramento CA Apartments with Air Conditioning",
      "h2_subtitle": "Stay cool in Sacramento, CA with Pheasant Pointe's air-conditioned apartments, offering comfort and modern amenities.",
      "page_copy": "Explore the comfort of living at Pheasant Pointe, where Sacramento CA apartments with air conditioning provide a refreshing sanctuary from the hustle and bustle of city life. Located in the heart of North Sacramento, our community offers efficiency and convenience, making it an ideal place to call home.\n\nResidents enjoy modern amenities like a cozy fireplace, Wi-Fi, and a vibrant community atmosphere with planned social activities. With air conditioning in every unit, you can relax in comfort all year round. The dedicated property manager on site ensures that all your needs are promptly addressed, enhancing your living experience. Discover a lifestyle of convenience and comfort at Pheasant Pointe, where air conditioning meets modern-day amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sacramento CA Apartments with Air Conditioning",
      "seo_description": "Enjoy air-conditioned comfort at Pheasant Pointe in Sacramento, CA. Modern amenities and a vibrant community await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "generator",
      "page_item_url": "apartments-dishwasher-sacramento-95833",
      "search_query": "apartments with dishwasher in sacramento 95833",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Sacramento 95833",
      "h2_subtitle": "Pheasant Pointe offers modern living in Sacramento with apartments featuring a dishwasher for added convenience.",
      "page_copy": "Located in the vibrant area of Sacramento 95833, Pheasant Pointe offers apartments with a dishwasher, making domestic chores a breeze. Our community is thoughtfully designed to cater to modern lifestyles, providing amenities that enhance comfort and convenience.\n\nApart from in-unit dishwashers, residents can enjoy the luxury of cozy fireplaces, easy access to high-speed Wi-Fi, and beautifully maintained outdoor spaces like a communal patio. With a dedicated property manager on site and a host of planned social activities, you'll find a warm community atmosphere at Pheasant Pointe. Experience ease and contemporary living in Sacramento's premier 95833 address.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Sacramento 95833",
      "seo_description": "Discover Pheasant Pointe in Sacramento 95833, where apartments with dishwashers offer modern convenience for contemporary living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-north-sacramento",
      "search_query": "one bedroom apartments north sacramento",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in North Sacramento",
      "h2_subtitle": "Pheasant Pointe offers stylish one-bedroom apartments in North Sacramento, designed for comfort and modern living.",
      "page_copy": "Discover the charm of one bedroom apartments at Pheasant Pointe, nestled in the heart of North Sacramento. These thoughtfully designed apartments provide the perfect balance of space and comfort, ideal for singles or couples.\n\nOur residents enjoy features like cozy fireplaces and private patios, enhancing the welcoming atmosphere. With a range of amenities including Wi-Fi and planned social activities, life at Pheasant Pointe offers convenience and community connections. Plus, with a dedicated property manager on site, you can rest easy knowing that your needs will be swiftly addressed. Experience the allure of modern living with a touch of community warmth at Pheasant Pointe's one bedroom residences.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in North Sacramento",
      "seo_description": "Find stylish one-bedroom apartments at Pheasant Pointe in North Sacramento. Enjoy modern living with cozy amenities and community vibes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166901",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-sacramento-county",
      "search_query": "two bedroom apartments sacramento county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Sacramento County",
      "h2_subtitle": "Experience spacious living at Pheasant Pointe with two bedroom apartments in Sacramento County, perfectly suited for families or roommates.",
      "page_copy": "Pheasant Pointe offers two bedroom apartments in Sacramento County that provide ample space and comfort, ideal for families or roommates seeking a homely touch. These well-designed apartments present the perfect blend of style and functionality, ensuring a comfortable living experience.\n\nResidents enjoy features such as cozy fireplaces, private patios, and efficient Wi-Fi connectivity. The community atmosphere is enriched through planned social activities, making it easy to connect with neighbors. With a dedicated property manager on site, you can relax knowing that any concerns you might have will be promptly addressed. Move into Pheasant Pointe in Sacramento County, where you can enjoy a blend of spacious living and a vibrant community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Sacramento County",
      "seo_description": "Explore Pheasant Pointe's two bedroom apartments in Sacramento County, featuring modern amenities and community activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5963"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372415952"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T4CBQDBZ"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "55609543285"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-654-2505 "
    }
  ],
  "custom_qb_id": "5963",
  "custom_repli_id": "18372415952",
  "custom_google_gtm_id": "GTM-T4CBQDBZ",
  "custom_hubspot_company_id": "55609543285",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-654-2505 "
};

export const generatedAt = '2026-09-23T19:55:39.455Z';
